import { Component, OnInit,Renderer2 } from '@angular/core';
import { BookingService } from '../services/booking.service';
import { Booking } from '../booking.model';
import { Modal, Toast } from 'bootstrap';
import { ToastService } from '../l_admin/toast.service';
import { ToastEvent } from '../l_admin/models/toast-event';
import { EventTypes } from '../l_admin/models/event-types';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

declare var $: any;

@Component({
  selector: 'app-booking-pelanggan',
  templateUrl: './booking-pelanggan.component.html',
  styleUrls: ['./booking-pelanggan.component.css']
})
export class BookingPelangganComponent implements OnInit {
  bookings: Booking[] = [];
  errorMessage: string | null = null;
  dtOptions: any = {};
  selectedBookingId: string | null = null;

  private Delmodal!: Modal;

  EventTypes = EventTypes;

  toasts: ToastEvent[] = [];
  private toastSubscription: Subscription;

  isModalVisible: boolean = false;
  ketBatal: string = '';  // To store the cancellation explanation

  constructor(private bookingService: BookingService, private renderer2: Renderer2, private toastService: ToastService,
     private router: Router,
  ) 
  {
    this.toastSubscription = this.toastService.toastEvents.subscribe(
      (event: ToastEvent) => {
        this.toasts = [...this.toasts, event];
        setTimeout(() => {
          this.toasts = this.toasts.filter(t => t !== event);
        }, 3000);
      }
    );
  }


  removeToast(toast: ToastEvent): void {
    this.toasts = this.toasts.filter(t => t !== toast);
  }


  ngOnInit(): void {
      this.initializeDataTable();
      this.loadbookings();

      setTimeout(() => {
        this.Delmodal = new Modal(document.getElementById('cancelModal')!);     
      });
   }


   loadbookings(): void {
    const userEmail = localStorage.getItem('user_email');
    if (userEmail) {
      this.bookingService.getBookingsByEmail(userEmail).subscribe({
        next: (data) => {
          this.bookings = data;
          this.renderDataTable();


          console.log(this.bookings);

          // if (this.bookings.status === 'cancelled') {
          //   this.ketBatal = this.bookings.ket_batal || 'No cancellation reason provided.';
          // }
        },
        error: (e) => console.error(e)
      });
    }


   } 

   


   initializeDataTable(): void {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      responsive: true,
      // Customize the DOM layout
      dom: `<'row align-items-center justify-content-between mb-3'
      <'col-12 col-md-auto'B>
      <'col-12 col-md-auto'f>
    >
    <'row'<'col-sm-12'tr>>
    <'row'
      <'col-sm-12 col-md-5'i>
      <'col-sm-12 col-md-7'p>
    >`,
      // Add buttons configuration
      buttons: [''],
      language: {
        search: '_INPUT_',
        searchPlaceholder: 'search',
        processing: '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>',
        paginate: {
          first: '<i class="fa fa-angle-double-left"></i>',
          previous: '<i class="fa fa-angle-left"></i>',
          next: '<i class="fa fa-angle-right"></i>',
          last: '<i class="fa fa-angle-double-right"></i>'
        },
        emptyTable: 'No data available'
      },
 
    };
   
  }


  statusClasses = [
    { status: 'PENDING', class: 'text-bg-primary' },
    { status: 'CONFIRMED', class: 'text-bg-success' },
    { status: 'CANCELLED', class: 'text-bg-danger' },
    { status: 'WAITING PAYMENT', class: 'text-bg-warning' },
    { status: 'PAID', class: 'text-bg-success' },
    { status: 'SETTLED', class: 'text-bg-success' },
    { status: 'EXPIRED', class: 'text-bg-danger' },
    { status: 'REFUNDED', class: 'text-bg-warning' } 
  ];
  
  renderDataTable(): void {
    const table = $('#bookTable').DataTable({
      ...this.dtOptions,
      destroy: true,
      data: this.bookings,
      columns: [
        {
          data: null,
          title: 'No.',
          orderable: false,
          className: 'dt-right align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any, type: any, row: any, meta: any) => {
            return meta.row + 1; // Render row number
          }
        },
        { 
          data: 'kode_booking', 
          title: 'Booking ID',
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any) => {
            // Link ke halaman detail booking dengan kode_booking
            return `<a href="/detail-booking/${data}" style="color:var(--warna-2); font-weight:bold; text-decoration:none;">${data}</a>`;
          }
        },
        {
          data: null,
          title: 'Cruise',
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any) => {
            return `<h6 class="mb-1">${data.nama_kapal}</h6>   <small class="text-muted">${data.boat_kategori}</small>`; // Gabungkan nama kapal dan jenis layanan
          }
        },
        { 
          data: 'guests', 
          title: 'Guest(s)', 
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any) => `${data} Guests` 
        },
        { 
          data: 'durasi', 
          title: 'Duration',
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
        },
        { 
          data: 'total', 
          title: 'Total', 
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any) => `IDR ${data.toLocaleString()}`
        },
        {
          data: null,
          title: 'Booking Period', // Mengganti nama kolom menjadi "Booking Period"
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any) => {
            const startDate = new Date(data.start_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            });
            const endDate = data.end_date ? new Date(data.end_date).toLocaleDateString('en-GB', {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            }) : 'N/A'; // Menangani jika end_date tidak tersedia
            
            return `${startDate} - ${endDate}`; // Gabungkan start_date dan end_date dalam satu kolom
          }
        },
        {
          data: 'status',
          orderable: false,
          title: 'Status',
          className: 'align-middle', // Menambahkan class untuk alignment vertikal
          render: (data: any, type: any, row: any) => {
            let displayStatus = data; // Gunakan status awal dari data
            let statusClass = this.statusClasses.find(item => item.status === displayStatus)?.class || 'text-bg-secondary';
          
           
            return `<span style="font-size:0.7rem" class="badge ${statusClass}">${displayStatus.charAt(0).toUpperCase() + displayStatus.slice(1)}</span>`;
          }
        },
        {
          data: null,
          title: '',
          orderable: false,
          className: 'align-middle text-end',
          render: (data: any) => {
            if (data.status === 'PENDING') {
              return `<button class="btn btn-outline-secondary btn-sm" #cancelBtn data-booking-id="${data.kode_booking}">
                       <i class="fa fa-trash" data-booking-id="${data.kode_booking}"></i>
                     </button>`;
            }
            return '';
          }
        }
      ]
    });


    const buttonElements = document.querySelectorAll('#bookTable button');
    buttonElements.forEach((button: Element) => {
      this.renderer2.listen(button, 'click', (event) => {
        const element = event.target as HTMLElement;
        const bookingId = element.getAttribute('data-booking-id') || 
                         element.closest('.cancel-btn')?.getAttribute('data-booking-id');
        
        if (bookingId) {
          this.openCancelModal(bookingId);
        }
      });
    });
  }

  openCancelModal(bookingId: string): void {
    this.selectedBookingId = bookingId;
    this.Delmodal.show();
  }

  confirmCancellation(): void {
    if (this.selectedBookingId) {
      this.bookingService.deleteBookingByCode(this.selectedBookingId).subscribe({
        next: () => {
          this.loadbookings();
          this.Delmodal.hide();
          this.toastService.showSuccessToast(
                'Success',
                'Reservation deleted successfully!'
              );
          this.toastService.clearSessionToast();
        },
        error: (error) =>   
          this.toastService.showErrorToast(
                      'Error',
                      'Failed to reload bookings. Please refresh the page.'
                    )
      });
    }
  }


  onStatusClick(): void {
    // if (this.bookings.status === 'cancelled') {
    //   this.isModalVisible = true;
    // }
  }

  closeModal(): void {
    this.isModalVisible = false;
  }

  
}



